var map = {
	"./assets/animations/A_new_kind_of_buy": 37,
	"./assets/animations/A_new_kind_of_buy.json": 37,
	"./assets/animations/Add_in_commercemanager": 38,
	"./assets/animations/Add_in_commercemanager.json": 38,
	"./assets/animations/Bag_checkout": 39,
	"./assets/animations/Bag_checkout.json": 39,
	"./assets/animations/Catalogue": 40,
	"./assets/animations/Catalogue.json": 40,
	"./assets/animations/Commerce_manager_header": 41,
	"./assets/animations/Commerce_manager_header.json": 41,
	"./assets/animations/Content Commerce Spin": 42,
	"./assets/animations/Content Commerce Spin.json": 42,
	"./assets/animations/ContentManager": 43,
	"./assets/animations/ContentManager.json": 43,
	"./assets/animations/Demoscroll_desktop": 44,
	"./assets/animations/Demoscroll_desktop.json": 44,
	"./assets/animations/EcomContent": 45,
	"./assets/animations/EcomContent.json": 45,
	"./assets/animations/Exclusive_offer": 46,
	"./assets/animations/Exclusive_offer.json": 46,
	"./assets/animations/Flying_box": 47,
	"./assets/animations/Flying_box.json": 47,
	"./assets/animations/Join_us": 48,
	"./assets/animations/Join_us.json": 48,
	"./assets/animations/New_kind_of_buy_spin": 49,
	"./assets/animations/New_kind_of_buy_spin.json": 49,
	"./assets/animations/New_kind_of_buy_spin_Alt": 50,
	"./assets/animations/New_kind_of_buy_spin_Alt.json": 50,
	"./assets/animations/New_kind_of_buy_spin_old": 51,
	"./assets/animations/New_kind_of_buy_spin_old.json": 51,
	"./assets/animations/OneLineOfCode": 52,
	"./assets/animations/OneLineOfCode.json": 52,
	"./assets/animations/Open_Close_Shop_Desktop": 53,
	"./assets/animations/Open_Close_Shop_Desktop.json": 53,
	"./assets/animations/Open_Close_Shop_mobile": 54,
	"./assets/animations/Open_Close_Shop_mobile.json": 54,
	"./assets/animations/Partnership_handshake": 55,
	"./assets/animations/Partnership_handshake.json": 55,
	"./assets/animations/PerfectForSome": 56,
	"./assets/animations/PerfectForSome.json": 56,
	"./assets/animations/Publisher_page_header_animation_noMasks": 57,
	"./assets/animations/Publisher_page_header_animation_noMasks.json": 57,
	"./assets/animations/Seller_page_header_animation_white": 58,
	"./assets/animations/Seller_page_header_animation_white.json": 58,
	"./assets/animations/ShopReel": 59,
	"./assets/animations/ShopReel.json": 59,
	"./assets/animations/ShopScroll": 60,
	"./assets/animations/ShopScroll.json": 60,
	"./assets/animations/ShopVsEditorial": 61,
	"./assets/animations/ShopVsEditorial.json": 61,
	"./assets/animations/Shop_box_animation_product_page": 62,
	"./assets/animations/Shop_box_animation_product_page.json": 62,
	"./assets/animations/Shop_this_buttons": 63,
	"./assets/animations/Shop_this_buttons.json": 63,
	"./assets/animations/SpotinAnimatedLogo": 64,
	"./assets/animations/SpotinAnimatedLogo.json": 64,
	"./assets/animations/Spotin_Song": 65,
	"./assets/animations/Spotin_Song.json": 65,
	"./assets/animations/SuperSimpleIntegration_onscroll": 66,
	"./assets/animations/SuperSimpleIntegration_onscroll.json": 66,
	"./assets/animations/Super_simple_integration": 67,
	"./assets/animations/Super_simple_integration.json": 67,
	"./assets/animations/Timeline - desktop_100px": 68,
	"./assets/animations/Timeline - desktop_100px.json": 68,
	"./assets/animations/Timeline - mobile_15px": 69,
	"./assets/animations/Timeline - mobile_15px.json": 69,
	"./assets/animations/Timeline_desktop": 70,
	"./assets/animations/Timeline_desktop.json": 70,
	"./assets/animations/Timeline_desktop_mobile": 71,
	"./assets/animations/Timeline_desktop_mobile.json": 71,
	"./assets/animations/WavingHand": 72,
	"./assets/animations/WavingHand.json": 72,
	"./assets/animations/ecom_content": 73,
	"./assets/animations/ecom_content.json": 73,
	"./assets/animations/marketing_to_commerce": 74,
	"./assets/animations/marketing_to_commerce.json": 74,
	"./assets/animations/portal_dashboard": 75,
	"./assets/animations/portal_dashboard.json": 75,
	"./assets/animations/product_page_full_width_Desktop": 76,
	"./assets/animations/product_page_full_width_Desktop.json": 76,
	"./assets/animations/product_page_side_panel_Desktop": 77,
	"./assets/animations/product_page_side_panel_Desktop.json": 77,
	"./assets/animations/startpage_header_animation": 78,
	"./assets/animations/startpage_header_animation.json": 78,
	"./assets/fonts/ABCMonumentGrotesk-Medium.woff": 33,
	"./assets/fonts/ABCMonumentGrotesk-Medium.woff2": 377,
	"./assets/fonts/ABCMonumentGrotesk-Regular.woff": 34,
	"./assets/fonts/ABCMonumentGrotesk-Regular.woff2": 378,
	"./assets/fonts/ABCMonumentGroteskSemi-Mono-Regular.woff": 35,
	"./assets/fonts/ABCMonumentGroteskSemi-Mono-Regular.woff2": 36,
	"./assets/fonts/LabilGrotesk-Bold.woff": 29,
	"./assets/fonts/LabilGrotesk-Bold.woff2": 30,
	"./assets/fonts/LabilGrotesk-Medium.woff": 31,
	"./assets/fonts/LabilGrotesk-Medium.woff2": 32,
	"./assets/fonts/icons/icons": 153,
	"./assets/fonts/icons/icons.eot": 379,
	"./assets/fonts/icons/icons.html": 380,
	"./assets/fonts/icons/icons.json": 153,
	"./assets/fonts/icons/icons.svg": 381,
	"./assets/fonts/icons/icons.ts": 382,
	"./assets/fonts/icons/icons.ttf": 383,
	"./assets/fonts/icons/icons.woff": 384,
	"./assets/fonts/icons/icons.woff2": 385,
	"./assets/imgs/Facebook_20x20.svg": 154,
	"./assets/imgs/Instagram_20x20.svg": 155,
	"./assets/imgs/Linkedin_20x20.svg": 156,
	"./assets/imgs/People/Board_Jonas_Eriksson_web.jpg": 157,
	"./assets/imgs/People/CFO_Robert_Karlsson_web.jpg": 158,
	"./assets/imgs/People/ceo_Kristoffer_Karlsson_web.jpg": 159,
	"./assets/imgs/Seller_contact_example.png": 160,
	"./assets/imgs/Seller_order-id_example.png": 161,
	"./assets/imgs/SpotinTechnical_desktop.svg": 162,
	"./assets/imgs/SpotinTechnical_mobile.svg": 163,
	"./assets/imgs/Spotin_SymbolS_Ring_Blue_Big_RGB.png": 164,
	"./assets/imgs/Spotin_SymbolS_Ring_Off_White_Big_RGB.png": 165,
	"./assets/imgs/Spotin_SymbolS_Ring_Off_White_Small_RGB.png": 166,
	"./assets/imgs/Spotin_SymbolS_Square_Off_White_Big_RGB.png": 167,
	"./assets/imgs/Stina_goya_scarf_hat.jpg": 168,
	"./assets/imgs/bok_amor_towles.png": 169,
	"./assets/imgs/bonnier.svg": 170,
	"./assets/imgs/chechout_from_shelf.png": 171,
	"./assets/imgs/circle_1.svg": 172,
	"./assets/imgs/circle_2.svg": 173,
	"./assets/imgs/circle_3.svg": 174,
	"./assets/imgs/circle_a_new_kind_of_buy.png": 175,
	"./assets/imgs/circle_commerce_on_your_terms.png": 176,
	"./assets/imgs/circle_simple_integration.png": 177,
	"./assets/imgs/circles_content_to_commerce.png": 178,
	"./assets/imgs/dollar.svg": 179,
	"./assets/imgs/exclusiveOffer.svg": 180,
	"./assets/imgs/heart.svg": 181,
	"./assets/imgs/little_liffner_TALL_TULIP TOTE_DUSTY_PINK.png": 182,
	"./assets/imgs/logo/Spotin_TM_Logo_Blue_Big_RGB.png": 183,
	"./assets/imgs/logo/Spotin_TM_Logo_Blue_Small_RGB.png": 110,
	"./assets/imgs/logo/Spotin_TM_Logo_Off-Black_Big_RGB.png": 184,
	"./assets/imgs/logo/Spotin_TM_Logo_Off-Black_Small_RGB.png": 111,
	"./assets/imgs/logo/Spotin_TM_Logo_Off-White_Big_RGB.png": 185,
	"./assets/imgs/logo/Spotin_TM_Logo_Off-White_Small_RGB.png": 112,
	"./assets/imgs/logo/Spotin_TM_Logo_Sand_Big_RGB.png": 186,
	"./assets/imgs/logo/Spotin_TM_Logo_Sand_Small_RGB.png": 113,
	"./assets/imgs/logo/Spotin_TM_Logo_True-White_Big_RGB.png": 187,
	"./assets/imgs/logo/Spotin_TM_Logo_True-White_Small_RGB.png": 188,
	"./assets/imgs/media1.jpg": 189,
	"./assets/imgs/media2.jpg": 190,
	"./assets/imgs/media3.jpg": 191,
	"./assets/imgs/media4.jpg": 192,
	"./assets/imgs/monetize_your_content.png": 193,
	"./assets/imgs/multiLanguages.svg": 194,
	"./assets/imgs/multiPaths.svg": 195,
	"./assets/imgs/news1.jpg": 196,
	"./assets/imgs/news1.png": 197,
	"./assets/imgs/news2.jpg": 198,
	"./assets/imgs/news3.jpg": 199,
	"./assets/imgs/news4.jpg": 200,
	"./assets/imgs/news5.jpg": 201,
	"./assets/imgs/news6.jpg": 202,
	"./assets/imgs/news7.jpg": 203,
	"./assets/imgs/offices_Dhaka.jpg": 204,
	"./assets/imgs/offices_Lulea.jpg": 205,
	"./assets/imgs/offices_Sthlm.jpg": 206,
	"./assets/imgs/orderreference.jpeg": 207,
	"./assets/imgs/orderreference.png": 208,
	"./assets/imgs/percent.svg": 209,
	"./assets/imgs/preOrder.svg": 210,
	"./assets/imgs/sneaker.png": 211,
	"./assets/imgs/sneaker2.png": 212,
	"./assets/imgs/sophiebysophie.svg": 213,
	"./assets/imgs/spotin_portal.png": 214,
	"./assets/imgs/spotin_portal.svg": 215,
	"./assets/imgs/swedish_stockings.png": 216,
	"./assets/imgs/timeline.png": 217,
	"./assets/imgs/venn_circles.png": 218,
	"./assets/imgs/venn_content_commerce.png": 219,
	"./assets/imgs/venn_content_commerce.svg": 220,
	"./assets/imgs/venn_content_commerce_mobile.png": 221,
	"./assets/imgs/venn_content_commerce_mobile.svg": 222,
	"./assets/imgs/venn_for_sellers.png": 223,
	"./assets/imgs/voguescandinavia.svg": 224,
	"./assets/index-demo.ejs": 386,
	"./assets/index-mobile.ejs": 387,
	"./assets/index.ejs": 388,
	"./assets/videos/Spotin.mp4": 225,
	"./assets/videos/WaveDesktop.mp4": 226,
	"./assets/videos/WaveMobile.mp4": 227,
	"./assets/videos/desktop_shop.mp4": 228,
	"./assets/videos/desktop_spot.mp4": 229,
	"./assets/videos/mobile_shop.mp4": 230,
	"./assets/videos/mobile_spot.mp4": 231,
	"./components/App.vue": 144,
	"./components/blocks/Animation.vue": 114,
	"./components/blocks/Article.vue": 232,
	"./components/blocks/Button.vue": 5,
	"./components/blocks/Circles.vue": 252,
	"./components/blocks/ColumnedExpandable.vue": 253,
	"./components/blocks/DropDown.vue": 254,
	"./components/blocks/Expandable.vue": 116,
	"./components/blocks/Html.vue": 255,
	"./components/blocks/Image.vue": 26,
	"./components/blocks/InputLabel.vue": 79,
	"./components/blocks/LogoList.vue": 256,
	"./components/blocks/Null.vue": 117,
	"./components/blocks/Related.vue": 257,
	"./components/blocks/Slider.vue": 258,
	"./components/blocks/Text.vue": 259,
	"./components/blocks/TextLink.vue": 6,
	"./components/blocks/TocIndex.vue": 260,
	"./components/blocks/ToggleButtons.vue": 454,
	"./components/combinedBlocks/Application.vue": 459,
	"./components/combinedBlocks/ArticleLoader.vue": 262,
	"./components/combinedBlocks/ColumnedExpandablelist.vue": 263,
	"./components/combinedBlocks/ExpandableList.vue": 118,
	"./components/combinedBlocks/FindSellerContact.vue": 264,
	"./components/combinedBlocks/GetStarted.vue": 265,
	"./components/combinedBlocks/HeaderFull.vue": 120,
	"./components/combinedBlocks/InputForm.vue": 100,
	"./components/combinedBlocks/IntegrationForm.vue": 266,
	"./components/combinedBlocks/PressReleases.vue": 268,
	"./components/combinedBlocks/Textarea.vue": 119,
	"./components/combinedBlocks/Toc.vue": 269,
	"./components/combinedBlocks/Video.vue": 121,
	"./components/combinedBlocks/Website.vue": 145,
	"./components/globalBlocks/FixedContainer.vue": 270,
	"./components/globalBlocks/FixedHolder.vue": 271,
	"./components/globalBlocks/FixedSections.vue": 272,
	"./components/globalBlocks/FlexBlock.vue": 109,
	"./components/globalBlocks/FlexButtons.vue": 273,
	"./components/globalBlocks/Footer.vue": 274,
	"./components/globalBlocks/Hamburger.vue": 275,
	"./components/globalBlocks/Icon.vue": 278,
	"./components/globalBlocks/Navigation.vue": 279,
	"./components/globalBlocks/ScrolledSections.vue": 282,
	"./components/globalBlocks/Sections.vue": 146,
	"./components/globalBlocks/SubSections.vue": 149,
	"./components/mixins/Button.vue": 251,
	"./components/mixins/EnableScroll.vue": 267,
	"./components/mixins/Hamburger.vue": 277,
	"./components/mixins/Link.vue": 80,
	"./components/mixins/Navigation.vue": 281,
	"./components/mixins/PlayVideo.vue": 550,
	"./components/mixins/PreventDefault.vue": 552,
	"./components/mixins/Sections.vue": 148,
	"./components/mixins/SubSections.vue": 151,
	"./components/mixins/Swipe.vue": 152,
	"./components/templates/Hamburger.vue": 276,
	"./components/templates/Logo.vue": 283,
	"./components/templates/Navigation.vue": 280,
	"./components/templates/Sections.vue": 147,
	"./components/templates/SubSections.vue": 150,
	"./constants": 106,
	"./constants.js": 106,
	"./demo/img/Anymag_logo.svg": 284,
	"./demo/img/Facebook_20x20.svg": 285,
	"./demo/img/Instagram_20x20.svg": 286,
	"./demo/img/Linkedin_20x20.svg": 287,
	"./demo/img/Spotin_SymbolS_Ring_Off_White_Small_RGB.png": 288,
	"./demo/img/Spotin_SymbolS_Square_Off_White_Big_RGB.png": 289,
	"./demo/img/Spotin_TM_Logo_Off-White_Big_RGB.png": 290,
	"./demo/img/Spotin_TM_Logo_Off-White_Small_RGB.png": 291,
	"./demo/img/Spotin_TM_Logo_Sand_Big_RGB.png": 292,
	"./demo/img/Spotin_TM_Logo_Sand_Small_RGB.png": 293,
	"./demo/img/articlelinkimage_1.jpg": 294,
	"./demo/img/articlelinkimage_2.jpg": 295,
	"./demo/img/articlelinkimage_3.jpg": 296,
	"./demo/img/articlelinkimage_4.jpg": 297,
	"./demo/img/book_1.png": 298,
	"./demo/img/book_2.png": 299,
	"./demo/img/bookarticle.jpg": 300,
	"./demo/img/header_1.jpg": 301,
	"./demo/img/header_1_new.jpg": 302,
	"./demo/img/header_2.jpg": 303,
	"./demo/img/trainingarticle_1.jpg": 304,
	"./demo/img/trainingarticle_2.jpg": 305,
	"./demo/img/trainingarticle_3.jpg": 306,
	"./demo/img/trendarticle_1.jpg": 307,
	"./demo/img/trendarticle_2.jpg": 308,
	"./demo/sass/style.sass": 28,
	"./demoSite": 101,
	"./demoSite.js": 101,
	"./fixed/Header.vue": 309,
	"./libs/anime": 310,
	"./libs/anime.js": 310,
	"./libs/color": 311,
	"./libs/color.js": 311,
	"./libs/scrollTo": 27,
	"./libs/scrollTo.js": 27,
	"./libs/tween": 312,
	"./libs/tween.js": 312,
	"./main": 104,
	"./main.js": 104,
	"./pageLoader": 125,
	"./pageLoader.js": 125,
	"./pages/About": 313,
	"./pages/About.js": 313,
	"./pages/Article": 314,
	"./pages/Article.js": 314,
	"./pages/Career": 315,
	"./pages/Career.js": 315,
	"./pages/Checkout": 316,
	"./pages/Checkout.js": 316,
	"./pages/ComingSoon": 317,
	"./pages/ComingSoon.js": 317,
	"./pages/Commercemanager": 318,
	"./pages/Commercemanager.js": 318,
	"./pages/Contact": 319,
	"./pages/Contact.js": 319,
	"./pages/Contentcommerce": 320,
	"./pages/Contentcommerce.js": 320,
	"./pages/Faq": 321,
	"./pages/Faq.js": 321,
	"./pages/Incontent": 322,
	"./pages/Incontent.js": 322,
	"./pages/Index": 323,
	"./pages/Index.js": 323,
	"./pages/Newcustomer": 324,
	"./pages/Newcustomer.js": 324,
	"./pages/News": 325,
	"./pages/News.js": 325,
	"./pages/Ordersupport": 326,
	"./pages/Ordersupport.js": 326,
	"./pages/Portal": 327,
	"./pages/Portal.js": 327,
	"./pages/Press": 328,
	"./pages/Press.js": 328,
	"./pages/Privacy": 329,
	"./pages/Privacy.js": 329,
	"./pages/Publishers": 330,
	"./pages/Publishers.js": 330,
	"./pages/Sellers": 331,
	"./pages/Sellers.js": 331,
	"./pages/Service": 332,
	"./pages/Service.js": 332,
	"./pages/Shop": 333,
	"./pages/Shop.js": 333,
	"./pages/Support": 334,
	"./pages/Support.js": 334,
	"./pages/Terms": 335,
	"./pages/Terms.js": 335,
	"./pages/content/career_EN": 128,
	"./pages/content/career_EN.js": 128,
	"./pages/content/comingSoon_EN": 129,
	"./pages/content/comingSoon_EN.js": 129,
	"./pages/content/comingSoon_SV": 336,
	"./pages/content/comingSoon_SV.js": 336,
	"./pages/content/ethicalGuidelines_EN": 337,
	"./pages/content/ethicalGuidelines_EN.js": 337,
	"./pages/content/ethicalGuidelines_SV": 338,
	"./pages/content/ethicalGuidelines_SV.js": 338,
	"./pages/content/faq_EN": 130,
	"./pages/content/faq_EN.js": 130,
	"./pages/content/faq_SV": 131,
	"./pages/content/faq_SV.js": 131,
	"./pages/content/integration_EN": 133,
	"./pages/content/integration_EN.js": 133,
	"./pages/content/integration_SV": 339,
	"./pages/content/integration_SV.js": 339,
	"./pages/content/orderSupport_EN": 134,
	"./pages/content/orderSupport_EN.js": 134,
	"./pages/content/portalOverview_EN": 135,
	"./pages/content/portalOverview_EN.js": 135,
	"./pages/content/privacy_EN": 136,
	"./pages/content/privacy_EN.js": 136,
	"./pages/content/privacy_SV": 137,
	"./pages/content/privacy_SV.js": 137,
	"./pages/content/sellers": 132,
	"./pages/content/sellers.js": 132,
	"./pages/content/terms_EN": 138,
	"./pages/content/terms_EN.js": 138,
	"./pages/content/terms_SV": 139,
	"./pages/content/terms_SV.js": 139,
	"./pages/media/10/10.jpg": 568,
	"./pages/media/10/article": 81,
	"./pages/media/10/article.json": 81,
	"./pages/media/11/11.jpg": 569,
	"./pages/media/11/article": 82,
	"./pages/media/11/article.json": 82,
	"./pages/media/12/12.jpg": 570,
	"./pages/media/12/article": 83,
	"./pages/media/12/article.json": 83,
	"./pages/media/14/14.jpg": 571,
	"./pages/media/14/article": 84,
	"./pages/media/14/article.json": 84,
	"./pages/media/15/15.jpg": 572,
	"./pages/media/15/article": 85,
	"./pages/media/15/article.json": 85,
	"./pages/media/16/16.jpg": 573,
	"./pages/media/16/article": 86,
	"./pages/media/16/article.json": 86,
	"./pages/media/18/18.jpg": 574,
	"./pages/media/18/article": 87,
	"./pages/media/18/article.json": 87,
	"./pages/media/19/19.jpg": 575,
	"./pages/media/19/article": 88,
	"./pages/media/19/article.json": 88,
	"./pages/media/2/article": 89,
	"./pages/media/2/article.json": 89,
	"./pages/media/2/no_image.jpg": 576,
	"./pages/media/20/20.png": 577,
	"./pages/media/20/article": 90,
	"./pages/media/20/article.json": 90,
	"./pages/media/21/21.png": 578,
	"./pages/media/21/article": 91,
	"./pages/media/21/article.json": 91,
	"./pages/media/22/22.png": 579,
	"./pages/media/22/article": 92,
	"./pages/media/22/article.json": 92,
	"./pages/media/3/3.jpg": 580,
	"./pages/media/3/article": 93,
	"./pages/media/3/article.json": 93,
	"./pages/media/4/4.jpg": 581,
	"./pages/media/4/article": 94,
	"./pages/media/4/article.json": 94,
	"./pages/media/5/5.jpg": 582,
	"./pages/media/5/article": 95,
	"./pages/media/5/article.json": 95,
	"./pages/media/6/6.jpg": 583,
	"./pages/media/6/article": 96,
	"./pages/media/6/article.json": 96,
	"./pages/media/7/7.jpg": 584,
	"./pages/media/7/article": 97,
	"./pages/media/7/article.json": 97,
	"./pages/media/8/8.jpg": 585,
	"./pages/media/8/article": 98,
	"./pages/media/8/article.json": 98,
	"./pages/media/9/9.jpg": 586,
	"./pages/media/9/article": 99,
	"./pages/media/9/article.json": 99,
	"./pages/news/1/Waqar_Spotin_news.jpg": 233,
	"./pages/news/1/article": 7,
	"./pages/news/1/article.json": 7,
	"./pages/news/10/North_star_web_news.png": 234,
	"./pages/news/10/article": 8,
	"./pages/news/10/article.json": 8,
	"./pages/news/11/article": 9,
	"./pages/news/11/article.json": 9,
	"./pages/news/11/oskar_lindholm_ceo.jpg": 235,
	"./pages/news/11/vinsider_sporthalsa.png": 236,
	"./pages/news/12/Andreas_Boman_Mathem.jpeg": 237,
	"./pages/news/12/article": 10,
	"./pages/news/12/article.json": 10,
	"./pages/news/12/tasteline.png": 238,
	"./pages/news/13/Spotin_x_Books.jpg": 239,
	"./pages/news/13/article": 11,
	"./pages/news/13/article.json": 11,
	"./pages/news/14/article": 12,
	"./pages/news/14/article.json": 12,
	"./pages/news/14/selma_stories.jpg": 240,
	"./pages/news/15/Bonnierforlagen_case_study.png": 241,
	"./pages/news/15/article": 13,
	"./pages/news/15/article.json": 13,
	"./pages/news/16/Portal_release.png": 242,
	"./pages/news/16/article": 14,
	"./pages/news/16/article.json": 14,
	"./pages/news/2/article": 15,
	"./pages/news/2/article.json": 15,
	"./pages/news/2/kristoffer_karlsson_news.jpg": 243,
	"./pages/news/3/Bonnierforlagen_X_Spotin_news.jpg": 244,
	"./pages/news/3/article": 16,
	"./pages/news/3/article.json": 16,
	"./pages/news/4/article": 17,
	"./pages/news/4/article.json": 17,
	"./pages/news/4/spotinxFIPP.jpg": 245,
	"./pages/news/5/SpotinxArctic15.png": 246,
	"./pages/news/5/article": 18,
	"./pages/news/5/article.json": 18,
	"./pages/news/6/article": 19,
	"./pages/news/6/article.json": 19,
	"./pages/news/6/futr_london.png": 247,
	"./pages/news/7/article": 20,
	"./pages/news/7/article.json": 20,
	"./pages/news/7/norstat_survey.jpg": 248,
	"./pages/news/8/DMEXCO_web_news.png": 249,
	"./pages/news/8/article": 21,
	"./pages/news/8/article.json": 21,
	"./pages/news/9/article": 22,
	"./pages/news/9/article.json": 22,
	"./pages/news/9/bits_pretzels_news_image.png": 250,
	"./pages/pressreleases/pressreleases": 103,
	"./pages/pressreleases/pressreleases.json": 103,
	"./sass/core.sass": 587,
	"./sass/fonts.scss": 25,
	"./sass/general.sass": 143,
	"./sass/icons.scss": 142,
	"./sass/mixins/animation.sass": 589,
	"./sass/mixins/bem.sass": 102,
	"./sass/mixins/gradient.sass": 591,
	"./sass/mixins/helpers.sass": 24,
	"./sass/mixins/pseudo.sass": 593,
	"./sass/mixins/responsive.sass": 595,
	"./sass/reset.scss": 597,
	"./sass/variables/color.sass": 599,
	"./sass/variables/fonts.sass": 601,
	"./store": 140,
	"./store.js": 140
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 376;


//////////////////
// WEBPACK FOOTER
// . ^\.\/.*$
// module id = 376
// module chunks = 0